import { useId } from 'react';
import { Field } from '@/shared/ui/field/field';
import { FieldDescription } from '@/shared/ui/field/field-description';
import { FieldLabel } from '@/shared/ui/field/field-label';
import { Switch } from '@/shared/ui/switch/switch';

type SwitchFieldProps = {
  readonly label: string;
  readonly hint?: string;
  readonly checked: boolean;
  readonly onChange: (checked: boolean) => void;
};

export function SwitchField({ label, hint, checked, onChange }: SwitchFieldProps) {
  const id = useId();
  return (
    <Field orientation="horizontal" className="items-center justify-between gap-4">
      <div className="flex flex-col gap-0.5">
        <FieldLabel htmlFor={id}>{label}</FieldLabel>
        {hint && <FieldDescription>{hint}</FieldDescription>}
      </div>
      <Switch id={id} checked={checked} onCheckedChange={onChange} />
    </Field>
  );
}
